export default "__VITE_PUBLIC_ASSET__1099b83c__"